function getDate(date) {
    if (date instanceof Date) return date;
    return new Date(date);
}

export function getDateComponents(date) {
    const dateObject = getDate(date);
    const _date = dateObject.getDate();
    const _month = dateObject.getMonth();
    const normalizedMonth = _month + 1;
    const _year = dateObject.getFullYear();

    return {
        date: _date,
        dateFullString: _date.toString().padStart(2, "0"),
        monthIndex: _month,
        month: _month,
        monthFullString: normalizedMonth.toString().padStart(2, "0"),
        yearFullString: _year,
    };
}

export function formatDate(date, format = "client") {
    if (!date) return "";
    
    const { dateFullString, monthFullString, yearFullString } = getDateComponents(date);

    if (format === "client") {
        return `${dateFullString}.${monthFullString}.${yearFullString}`;
    }

    return date;
}
